"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGeoJsonIdToAssetDictionary = void 0;
const client_1 = require("@apollo/client");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const lodash_1 = require("lodash");
const react_1 = require("react");
function useGeoJsonIdToAssetDictionary(locationId, floorLevel) {
    const { data } = client_1.useQuery(QUERY, {
        variables: { locationId, floorLevel },
        context: { locationId },
        skip: floorLevel === null || isNaN(floorLevel),
        fetchPolicy: 'cache-first',
    });
    const dict = react_1.useMemo(() => {
        var _a, _b;
        const list = (_b = (_a = data === null || data === void 0 ? void 0 : data.location) === null || _a === void 0 ? void 0 : _a.units) === null || _b === void 0 ? void 0 : _b.list;
        if (!list) {
            return {};
        }
        return lodash_1.mapValues(lodash_1.groupBy(list, unit => {
            var _a, _b;
            if (unit.geoJSON.length) {
                try {
                    const geoJsonId = JSON.parse((_b = (_a = unit.geoJSON[0]) === null || _a === void 0 ? void 0 : _a.stringValue) !== null && _b !== void 0 ? _b : '').href;
                    return geoJsonId;
                }
                catch (e) {
                    return undefined;
                }
            }
        }), units => { var _a; return (_a = units[0].unitAddress) === null || _a === void 0 ? void 0 : _a.did; });
    }, [data]);
    return dict;
}
exports.useGeoJsonIdToAssetDictionary = useGeoJsonIdToAssetDictionary;
const QUERY = graphql_tag_1.default `
  query GeoJsonIdForAssets($locationId: String!, $floorLevel: Int) {
    location(locationId: $locationId) {
      key
      units(first: 10000, floorLevel: $floorLevel) {
        list {
          key
          unitAddress {
            did
            key
          }
          geoJSON: property(propertyName: geoJSON) {
            stringValue
            key
          }
        }
      }
    }
  }
`;
//# sourceMappingURL=useGeoJsonIdToAssetDictionary.js.map